import api from "../services/Api";

async  function inicial(){
    return api().get('/ebot');
}

// async  function pesquisar(busca){
//     return api().get('/artigo/' + busca);
// }

async  function processar(interacaoDto){
    return api().post('/ebot', interacaoDto);
}

export { inicial, processar };
